var path = 'templates/partial/quake.html';
var html = "<img ng-src=./resources/img/quake.png class=md-avatar /> <div class=md-list-item-text> <h3><b> <span ng-if=quake.getName()>［{{quake.getName()}}］</span> {{quake.getDateString()}}（{{quake.getDateJP()}}） </b></h3> <p> 地域：{{quake.data.region}}<br> <span ng-if=quake.data.magnitude> マグニチュード：{{quake.data.magnitude}} </span> </p> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/partial/quake.html
// module id = 46
// module chunks = 0